import React from 'react';

export function IconPhone({
  width = 21,
  height = 21,
  color = '#1A1A1A',
}: {
  width?: number;
  height?: number;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
    >
      <g clipPath="url(#clip0_1_951)">
        <path
          d="M15.3502 20.8799C13.528 20.8799 11.7502 20.5465 10.0169 19.8799C8.19464 19.1688 6.58353 18.1021 5.18353 16.6799C3.78353 15.2577 2.70575 13.6354 1.9502 11.8132C1.28353 10.0799 0.950195 8.3021 0.950195 6.47988C0.950195 5.45766 1.20575 4.52433 1.71686 3.67988C2.22797 2.83544 2.90575 2.15766 3.7502 1.64655C4.59464 1.13544 5.52797 0.879881 6.5502 0.879881C6.81686 0.879881 6.99464 1.01322 7.08353 1.27988L9.61686 7.54655C9.66131 7.67988 9.6502 7.82433 9.58353 7.97988C9.51686 8.13544 9.41686 8.23544 9.28353 8.27988L6.5502 9.41322C6.59464 10.4354 6.88353 11.391 7.41686 12.2799C7.9502 13.1688 8.66131 13.8799 9.5502 14.4132C10.4391 14.9465 11.3946 15.2354 12.4169 15.2799L13.5502 12.5465C13.5946 12.4132 13.6946 12.3132 13.8502 12.2465C14.0058 12.1799 14.1502 12.1688 14.2835 12.2132L20.5502 14.7465C20.8169 14.8354 20.9502 15.0132 20.9502 15.2799C20.9502 16.3021 20.6946 17.2354 20.1835 18.0799C19.6724 18.9243 18.9946 19.6021 18.1502 20.1132C17.3058 20.6243 16.3724 20.8799 15.3502 20.8799ZM6.1502 2.07988C5.03908 2.16877 4.09464 2.63544 3.31686 3.47988C2.53908 4.32433 2.1502 5.32433 2.1502 6.47988C2.1502 8.25766 2.48353 9.94655 3.1502 11.5465C3.81686 13.1465 4.77242 14.5688 6.01686 15.8132C7.26131 17.0577 8.68353 18.0132 10.2835 18.6799C11.8835 19.3465 13.5724 19.6799 15.3502 19.6799C16.5058 19.6799 17.5058 19.291 18.3502 18.5132C19.1946 17.7354 19.6613 16.791 19.7502 15.6799L14.4169 13.5465L13.3502 16.1465C13.2613 16.3688 13.0835 16.4799 12.8169 16.4799C11.4835 16.4799 10.2391 16.1465 9.08353 15.4799C7.92797 14.8132 7.01686 13.9021 6.3502 12.7465C5.68353 11.591 5.3502 10.3465 5.3502 9.01322C5.3502 8.74655 5.46131 8.56877 5.68353 8.47988L8.28353 7.41322L6.1502 2.07988Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_951">
          <rect width={20} height={20} fill="white" transform="matrix(1 0 0 -1 0.950195 20.8799)" />
        </clipPath>
      </defs>
    </svg>
  );
}
